import AccessInstantPay from "components/Tutorials/InstantPayTutorial.tsx/AccessInstantPay";
import HowInstantPayWorks from "components/Tutorials/InstantPayTutorial.tsx/HowInstantPayWorks";
import {
  InstantPayTutorialStep,
  InstantPayTutorialStepEnum,
} from "components/Tutorials/InstantPayTutorial.tsx/InstantPayTutorial";
import SetupPaymentmethod from "components/Tutorials/InstantPayTutorial.tsx/SetupPaymentmethod";
import React from "react";

interface IStepRendererProps {
  selectedStep: InstantPayTutorialStep;
  setLastCompletedStep: (id: number) => void;
  qrUrl: string;
  businessUuid?: string;
}
const StepRenderer: React.FC<IStepRendererProps> = ({
  selectedStep,
  setLastCompletedStep,
  businessUuid,
  qrUrl,
}) => {
  switch (selectedStep.step) {
    case InstantPayTutorialStepEnum.QRC0DE:
      return <HowInstantPayWorks setLastCompletedStep={setLastCompletedStep} />;
    case InstantPayTutorialStepEnum.SETUP:
      return <SetupPaymentmethod setLastCompletedStep={setLastCompletedStep} />;
    case InstantPayTutorialStepEnum.ACCESS:
      return (
        <AccessInstantPay
          setLastCompletedStep={setLastCompletedStep}
          qrUrl={qrUrl}
          businessUuid={businessUuid || ""}
        />
      );
    default:
      return null;
  }
};

export default StepRenderer;
